/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { loadClientRuntimeConfig } from "./lib/runtime-config";
import { installAccessInterceptor } from "./lib/access-events";

const elem = document.getElementById("root")!;

const renderApp = async () => {
  installAccessInterceptor();
  await loadClientRuntimeConfig();
  const { default: App } = await import("./App");

  const app = (
    <StrictMode>
      <App />
    </StrictMode>
  );

  if (import.meta.hot) {
    // With hot module reloading, `import.meta.hot.data` is persisted.
    const root = (import.meta.hot.data.root ??= createRoot(elem));
    root.render(app);
    return;
  }

  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
};

void renderApp();
